module.exports = __webpack_public_path__ + "static/media/Magnezone_gaussian2.f524c353.png";